import { Typography } from '@mui/material';
import { useStyles } from './styles';
import { type ReactNode } from 'react';
import Grid2 from '@mui/material/Unstable_Grid2';

type FeatureProps = {
  label: string | ReactNode;
  children?: ReactNode;
  PostIcon?: ReactNode;
  hide?: boolean;
};

const Feature = ({ label, children, PostIcon, hide }: FeatureProps) => {
  const classes = useStyles();

  if (hide) {
    return <></>;
  }

  return (
    <Typography variant="body1">
      <Grid2 className={classes.featureWrapper}>
        <Grid2 xs={12} sm="auto" className={classes.labelName}>
          <div>{label}</div>
          {PostIcon ?? <></>}
          {!PostIcon ? <div>:</div> : <></>}
        </Grid2>
        {children && (
          <Grid2 sx={{ paddingRight: 2 }} className={classes.featureValue} xs={12} sm="auto">
            {children}
          </Grid2>
        )}
      </Grid2>
    </Typography>
  );
};

export default Feature;
